'use client'

import React, { useContext, useEffect, useState } from 'react'
import { Icon } from '@/components/Icon'
import { PushContext, PushContextType } from '@/context/PushContext'
import { checkPushInit } from '@/libs/Pushes/pushes.lib'
import styles from './PushButton.module.scss'
import { getAppConfig } from '@/config/config'
import { notifyError } from '@/libs/bugsnag/bugsnag'
import { isBrowser } from '@/utils/app/detect'
import AppContext from '@/types/context'
import { FeatureFlagService } from '@/services/api/unleash/FeatureFlag.service'
import { FF_WEBPUSH } from '@/config/featureFlags'

declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    pushDelivery: any
  }
}

const PushButton = ({ context }: { context: AppContext }) => {
  const [showButton, setShowButton] = useState(false)
  const pushContext = useContext(PushContext)

  useEffect(() => {
    if (isBrowser() && globalThis.window.Notification) {
      setShowButton(true)
    }
  }, [])

  if (!FeatureFlagService.isFeatureFlagEnabled(context.featureFlags, FF_WEBPUSH)) {
    return null
  }

  const config = getAppConfig()
  const basePath = config.basePath

  const { updateIsOpen, updatePermission } = pushContext as PushContextType

  const onPushClick = () => {
    if (globalThis.window?.Notification?.permission === 'granted') {
      globalThis.window.location.href = `${basePath}/browserpush/`
      return
    }
    localStorage.removeItem('askDenied')
    checkPushInit(updateIsOpen, updatePermission).catch((error) => {
      notifyError('pushDelivery not available', {
        scope: PushButton.name,
        message: error.message,
        stack: error.stack,
      })
      globalThis.window.alert('Bitte erlauben Sie Push Nachrichten in den Einstellungen des Browsers.')
    })
  }

  return (
    showButton && (
      <button className={styles['icon-button']} onClick={onPushClick} aria-label="Push Nachrichten">
        <Icon name="push" size={18} title="Push Nachrichten" />
      </button>
    )
  )
}

export default PushButton
